import Server from './server'

export default {
  Server,
}
